import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitConsultation = (data) => api.post("/consultation", data).then((r) => r.data);
export const submitServiceRequest = (data) => api.post("/service-request", data).then((r) => r.data);
export const subscribe = (data) => api.post("/subscribe", data).then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getResources = () => api.get("/resources").then((r) => r.data);
